import { UploadDocumentAws } from 'domain/usecases/document/upload-document-aws'
import { AwsDocumentRepository } from 'repository/interfaces/aws-document-repository'

export class RemoteUploadDocumentAws implements UploadDocumentAws {
  private readonly documentRepository: AwsDocumentRepository

  constructor(documentRepository: AwsDocumentRepository) {
    this.documentRepository = documentRepository
  }

  upload(params: UploadDocumentAws.Params): Promise<UploadDocumentAws.Model> {
    return this.documentRepository.uploadDocumentAws(params)
  }
}

export type UploadDocumentAwsModel = UploadDocumentAws.Model
